<div class="bg-white px-6 py-20 md:px-12 lg:px-20">
	<div class="flex flex-col items-center gap-4 mb-16">
		<app-headline-large [title]="content.title"></app-headline-large>
		<app-body-large [description]="content.description"></app-body-large>
	</div>

	<div class="flex flex-col gap-16">
		<div class="flex flex-col lg:flex-row gap-16">
			<div class="flex flex-col justify-between flex-1 items-center lg:items-end">
				@for (item of leftList; track item.title) {
				<div
					pAnimateOnScroll
					enterClass="animate-enter fade-in-10 zoom-in-50 animate-duration-1000"
					class="w-full lg:max-w-md rounded-xl flex flex-col items-center lg:items-end gap-4 p-4 pl-0">
					<div class="flex items-center justify-center">
						<i
							[ngClass]="item?.image?.src"
							class="text-2xl! text-primary-500"></i>
					</div>
					<div class="flex flex-col items-center lg:items-end gap-3 w-full">
						<h3
							class="text-lg leading-tight font-semibold text-surface-900 dark:text-surface-0 text-center lg:text-right"
							[innerHTML]="item.title"></h3>
						<p
							class="text-base leading-normal text-surface-600 dark:text-surface-400 text-center lg:text-right"
							[innerHTML]="item.description"></p>
					</div>
				</div>
				}
			</div>

			@if (content.image){
			<div class="@[1024px]:hidden w-full lg:w-[26.57rem] h-[28.29rem] mx-auto flex justify-center">
				<img
					class="h-full"
					[src]="content.image.src"
					[alt]="content.image.alt" />
			</div>
			}

			<div class="flex flex-col justify-between flex-1 items-center lg:items-start">
				@for (item of rightList; track item.title) {
				<div
					pAnimateOnScroll
					enterClass="animate-enter fade-in-10 zoom-in-50 animate-duration-1000"
					class="w-full lg:max-w-md rounded-xl flex flex-col items-center lg:items-start gap-4 p-4 pl-0">
					<div class="flex items-center justify-center">
						<i
							[ngClass]="item?.image?.src"
							class="text-2xl! text-primary-500"></i>
					</div>
					<div class="flex flex-col items-center lg:items-start gap-3 w-full">
						<h2
							class="text-lg leading-tight font-semibold text-surface-900 dark:text-surface-0 text-center lg:text-left"
							[innerHTML]="item.title"></h2>
						<p
							class="text-base leading-normal text-surface-600 dark:text-surface-400 text-center lg:text-left"
							[innerHTML]="item.description"></p>
					</div>
				</div>
				}
			</div>
		</div>
	</div>
</div>
